export let CUSTOMER_TYPE_DROPDOWN_FILTER = 'customer_type_dropdown_filter';
export let EQUIPMENT_SERIAL_NUMBER = 'equipment_serial_number';
export let COMPLETED_NOTES_KP = 'completed_notes_kp';
export let BOOKED_IN_BY = 'booked_in_by';
export let ESTIMATED_TOTAL_COST_KP = 'estimated_total_cost_kp';
export let QUOTATION_ACCEPTED_BY = 'quotation_accepted_by';
export let CANCELLED_BY = 'cancelled_by';
export let COMPLETED_BY = 'completed_by';
export let LABOUR_COST_KP = 'labour_cost_kp';
export let LABOUR_HOURS_KP = 'labour_hours_kp';
export let MARKED_WAITING_PARTS_BY = 'marked_waiting_parts_by';
export let WAITING_FOR_PARTS_NOTES_KP = 'waiting_for_parts_jp';
export let QUOTATION_ACCPTED_VIA_EMAIL = 'quotation_accepted_via_email';
export let QUOTE_APPROVED_NOTES_KP = 'quote_approved_notes_kp';
export let EMAIL_SENT_TO_KP = 'email_sent_to_kp';
export let WORK_REQUIRED_KP = 'work_required_kp';
export let ASSESSED_BY = 'assessed_by';
export let ESTIMATED_PARTS_COST_KP = 'estimated_parts_cost_kp';
export let ESTIMATED_LABOUR_HOURS = 'estimated_labour_hours';
export let ASSESSMENT_SUMMARY = 'assessment_Summary';
export let WORKSHOP_EVENT = 'workshop_event';
export let EVENT_TYPE_FIELD = 'event_Type_field';
export const SAVE_WAITING_FOR_PARTS_BUTTON = 'save_waiting_for_parts_button';
export const WAITING_FOR_PARTS_NOTES_INPUT = 'waiting_for_parts_notes_input';
export const SAVE_REPAIR_STARTED_BUTTON = 'save_repair_started_button';
export const REPAIR_STARTED_NOTES_INPUT = 'repair_started_notes_input';
export const SAVE_QUOTE_APPROVED_BUTTON = 'save_quote_approved_button';
export const QUOTE_APPROVED_NOTES = 'quote_approved_notes';
export const WORK_REQUIRED_INPUT = 'work_required_input';
export const EMAIL_QUOTATION_CHECKBOX = 'email_quotation_checkbox';
export const QUOTATION_RECIPIENT_INPUT = 'quotation_recipient_input';
export const ADD_QUOTATION_BUTTON = 'add-quotation';
export const PROVIDE_DATA_FROM_ASSESSMENT = 'provide_data_from_assessment';
export const COMPLETED_SAVE_BUTTON = 'complete_save_button';
export const COMPLETED_NOTES_INPUT = 'completed_notes_input';
export const SAVE_CANCELLATION_BUTTON = 'save_cancellation_button';
export const CANCEL_EVENT_DIALOG_BUTTON = 'cancel_event_dialog';
export const CANCELLATION_NOTES_INPUT = 'cancellation_notes_input';
export const LABOUR_COST_INPUT = 'labour_cost';
export const LABOUR_HOURS_INPUT = 'labour_hours';
export const ASSESSMENT_SUMMARY_INPUT = 'assessment_summary';
export const ESTIMATED_LABOUR_HOURS_INPUT = 'estimated_labour_hours';
export const ESTIMATED_PARTS_COST = 'estimated_parts_cost';
export const ESTIMATED_TOTAL_COST_INPUT = 'estimated_total_cost';
export const ADD_ASSESSMENT_BUTTON = 'add-assessment';
export const CANNOT_TAKE_ACTION_MESSAGE = 'cannot_take_actions';
export const OTHER_ACTION_PREFIX = 'other_action_';
export const OTHER_ACTIONS_DROPDOWN = 'other_actions_dropdown';
export const PRIMARY_ACTION_BUTTON = 'primary_action_button';
export const JOB_NAME = 'job-name';
export const JOB_ID = 'job-id';
export const VIEW_ITEM_HISTORY = 'view-item-history';
export const JOB_STATUS = 'job-status';
export const JOB_DETAILS = 'job-details';
export const JOB_NOTES = 'job-notes';
export const DOCKET_LINK = 'docket-link';
export const PARTS_ITEM_TABLE = 'parts_item_table';
export const PARTS_LIST = 'parts_list';
export const EVENT_PREFIX = 'event_id_';
export const EVENTS_LIST = 'events_list';
export const CUSTOMER_ADDRESS = 'customer_address';
export const CUSTOMER_CONTACT_DETAILS = 'customer_contact_details';
export const CUSTOMER_INTERNAL_REPAIR = 'internal_repair';
export const CUSTOMER_NAME = 'CUSTOMER_NAME';
export const WORKSHOP_SEARCH_FILTER = 'WORKSHOP_SEARCH_FILTER';
export const WORKSHOP_STATUS_DROPDOWN_FILTER = 'WORKSHOP_STATUS_FILTER';
export const WORKSHOP_JOB_LIST_TABLE = 'WORKSHOP_JOB_LIST_TABLE';
export const CUSTOMER_CARD = 'CUSTOMER_CARd';
